import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVolumeHalf: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVolumeHalf"><Path d="M13 20.9289V3.07104L5.74656 6.99999H1V17H5.74656L13 20.9289Z" fill="currentColor"/><Path d="M16.5 12.0005C16.5 10.7576 15.9974 9.63394 15.182 8.81851L16.5962 7.4043C17.7714 8.57947 18.5 10.2058 18.5 12.0005C18.5 13.7951 17.7714 15.4215 16.5962 16.5967L15.182 15.1825C15.9974 14.367 16.5 13.2434 16.5 12.0005Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVolumeHalf;
